
const initialState={
    recommendedCurrentTab:0,
    pegaRecommendationBundleData:{},
    pegafeedbackarray : [],
    pegaSeqCntrl : true,
    actionCTriggred : null
}
function pegaRecommendation(state = initialState, action) {

    switch (action.type) {
        case "HANDLE_RECOMMENDED_TAB":
            return{
                ...state,
                recommendedCurrentTab:action.value
            }
        case "SET_PEGA_BUNDLE_DATA":
            return {
                ...state,
                pegaRecommendationBundleData:action.value
            } 
        case "PEGA_FEEDBACK":
            let pegafeedbackstate = action.value
            pegafeedbackstate.Sequence = state.pegafeedbackarray.length + 1
            return {
                ...state,
                pegafeedbackarray : [...state.pegafeedbackarray,pegafeedbackstate]
            }   
        case "SEQUENCE_CONTROL":
            return {
                ...state,
                pegaSeqCntrl: action.value
            } 
        case "ACTIONC_TRIGGRED":
            return {
                ...state,
                actionCTriggred: action.value
            } 
        default:
            return state
    }
}


export default pegaRecommendation